import { useStaticQuery, graphql } from "gatsby"
export const useHomePageSanityData = () => {
  const data = useStaticQuery(graphql`
    query allhomepage {
      allSanityPage(filter: { title: { eq: "Home" } }) {
        nodes {
          title
          Logo {
            asset {
              url
            }
          }
          slide {
            ... on SanitySlide {
              slide_title
              slide_name
              slide_subtitle
              content_footer
              _rawNewSlideTitle
              _rawNewSlideSubtitle
              cta_title
              _rawLatestNews
              content
              slide_title_image {
                asset {
                  url
                }
              }
              mobile_slide_title_image {
                asset {
                  url
                }
              }
              content_image_desktop_view {
                asset {
                  url
                }
              }
              cta {
                ... on SanityCta {
                  cta_name
                  cta_link
                  cta_style
                  is_youtube_video
                  show_icon
                }
              }
              uniqueValues {
                title
                valueDescription
                isHomepageDesign
                image {
                  asset {
                    url
                  }
                }
                valueIcon {
                  asset {
                    url
                  }
                }
                cta {
                  show_icon
                  is_youtube_video
                  cta_name
                  cta_link
                  cta_style
                  cta_icon {
                    asset {
                      url
                    }
                  }
                }
              }
              carousel {
                cardTitle
                industry
                video
                technology
                mainImage {
                  asset {
                    url
                  }
                }
                content
                slug {
                  current
                }
              }
              trustedBrands {
                brand_name
                brands_logo {
                  asset {
                    url
                  }
                }
              }
              trustedBrandsSecondRow {
                brand_name
                brands_logo {
                  asset {
                    url
                  }
                }
              }
              techolutionStats {
                title
                description
              }
              AIAccelerators {
                MenuTitle
                cardType
                slug {
                  current
                }
                MenuImage {
                  asset {
                    url
                  }
                }
                CTARedirect
                MenuDescription
                MenuDescriptionPreview
                useCase
              }
              solutionsMenu {
                MenuTitle
                cardType
                slug {
                  current
                }
                MenuImage {
                  asset {
                    url
                  }
                }
                MenuDescriptionPreview
                MenuDescription
                CTARedirect
                useCase
              }
              Awards {
                AwardYear
                AwardImage {
                  asset {
                    url
                  }
                }
                AwardDescription
                LearnMore
              }
              popupCards {
                popupTitle
                popupImage {
                  asset {
                    url
                  }
                }
                popupDescriptionPreview
                popupDescription
              }
              provenResults {
                title
                percentage
              }
            }
            ... on SanityNewSlide {
              _rawTitle
              _rawSubtitle
              _rawLatestNews
              slide_bg
              slideClassName
              _rawFooterText
              _rawCtaText
              _rawContent
              type
              cards {
                cardName
                _rawTitle
                _rawDescription
                miscContent
                imageAlt
                impactMeter
                Title {
                  children {
                    text
                  }
                }
                cta {
                  ... on SanityCta {
                    cta_style
                    cta_name
                    cta_link
                    cta_icon {
                      asset {
                        url
                      }
                    }
                  }
                }
                cardImage {
                  asset {
                    url
                  }
                }
                description {
                  children {
                    text
                  }
                }
              }
              animations {
                animationName
                animationFile {
                  asset {
                    url
                  }
                }
              }
              backgroundImage {
                asset {
                  url
                }
              }
              backgroundImageMobile {
                asset {
                  url
                }
              }
              backgroundVideos {
                asset {
                  url
                  mimeType
                }
              }
              cta {
                ... on SanityCta {
                  cta_name
                  cta_style
                  cta_link
                  cta_icon {
                    asset {
                      url
                    }
                  }
                }
              }
              form
              topCTA
              showTimsBtn
              carousel {
                cardTitle
                industry
                video
                technology
                mainImage {
                  asset {
                    url
                  }
                }
                content
                slug {
                  current
                }
              }
              trustedBrands {
                brand_name
                brands_logo {
                  asset {
                    url
                  }
                }
              }
              trustedBrandsSecondRow {
                brand_name
                brands_logo {
                  asset {
                    url
                  }
                }
              }
              products {
                MenuTitle
                cardType
                slug {
                  current
                }
                MenuImage {
                  asset {
                    url
                  }
                }
                CTARedirect
                MenuDescription
                MenuDescriptionPreview
                useCase
              }
            }
          }
        }
      }
    }
  `)
  return data
}
